import React from "react";
import { CardBody } from "reactstrap";

const Content = ({ component }) => {
  return <CardBody>{component}</CardBody>;
};

export default Content;
